/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerGetProjectGroupsQueryResponse, GroupsControllerGetProjectGroupsPathParams, GroupsControllerGetProjectGroupsQueryParams, GroupsControllerGetProjectGroups400, GroupsControllerGetProjectGroups401, GroupsControllerGetProjectGroups403, GroupsControllerGetProjectGroups404 } from "../../models/documentGroupsController/GroupsControllerGetProjectGroups";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { groupsControllerGetProjectGroups } from "../../clients/document-groupsService/groupsControllerGetProjectGroups";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const groupsControllerGetProjectGroupsQueryKey = (projectId: GroupsControllerGetProjectGroupsPathParams["projectId"], params: GroupsControllerGetProjectGroupsQueryParams) => [{
  url: '/api/v1/documents/groups/projects/:projectId',
  params: {
    projectId: projectId
  }
}, ...(params ? [params] : [])] as const;
export type GroupsControllerGetProjectGroupsQueryKey = ReturnType<typeof groupsControllerGetProjectGroupsQueryKey>;
export function groupsControllerGetProjectGroupsQueryOptions(projectId: GroupsControllerGetProjectGroupsPathParams["projectId"], params: GroupsControllerGetProjectGroupsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = groupsControllerGetProjectGroupsQueryKey(projectId, params);
  return queryOptions<GroupsControllerGetProjectGroupsQueryResponse, ResponseErrorConfig<GroupsControllerGetProjectGroups400 | GroupsControllerGetProjectGroups401 | GroupsControllerGetProjectGroups403 | GroupsControllerGetProjectGroups404>, GroupsControllerGetProjectGroupsQueryResponse, typeof queryKey>({
    enabled: !!(projectId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return groupsControllerGetProjectGroups(projectId, params, config);
    }
  });
}

/**
 * @description Returns every group of the requested type(s) with at least one member document in the project. Members are `document-group-members` resources (rank, role, reason, status, citations with resolved source/target annotations) and sideload via `include=members`; their documents sideload via `include=members.document`. Members of VERSIONED or DELETED documents are omitted. A group spanning several projects returns every member the caller may read. Intended for hundreds of documents; the whole collection is returned, not paginated.
 * @summary List document groups for a project
 * {@link /api/v1/documents/groups/projects/:projectId}
 */
export function useGroupsControllerGetProjectGroups<TData = GroupsControllerGetProjectGroupsQueryResponse, TQueryData = GroupsControllerGetProjectGroupsQueryResponse, TQueryKey extends QueryKey = GroupsControllerGetProjectGroupsQueryKey>(projectId: GroupsControllerGetProjectGroupsPathParams["projectId"], params: GroupsControllerGetProjectGroupsQueryParams, options: {
  query?: Partial<QueryObserverOptions<GroupsControllerGetProjectGroupsQueryResponse, ResponseErrorConfig<GroupsControllerGetProjectGroups400 | GroupsControllerGetProjectGroups401 | GroupsControllerGetProjectGroups403 | GroupsControllerGetProjectGroups404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? groupsControllerGetProjectGroupsQueryKey(projectId, params);
  const query = useQuery({
    ...groupsControllerGetProjectGroupsQueryOptions(projectId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GroupsControllerGetProjectGroups400 | GroupsControllerGetProjectGroups401 | GroupsControllerGetProjectGroups403 | GroupsControllerGetProjectGroups404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}